import React from "react";

export const themes = {
  headerWhite: false,
  headerColor: "white",
  defaultScrolled: false,
  light: {
    foreground: "#000000",
    background: "#eeeeee"
  },
  dark: {
    foreground: "#ffffff",
    background: "#222222"
  }
};

export const ThemeContext = React.createContext({
  headerColor: themes.headerColor,
  defaultScrolled: themes.defaultScrolled,
  changeHeaderColor: () => {}
});
